/** Base class providing simple listener callback functionality */
export class DataListener {
    constructor() {
        this.listeners = new Map();
        this.lastId = 0;
    }
    /** add a listener that is called whenever new data is available */
    addListener(callback) {
        if (!callback) {
            throw new Error('No callback provided for data listener');
        }
        this.listeners.set(this.lastId, callback);
        return this.lastId++;
    }
    /** removes a previously added listener */
    removeListener(id) {
        this.listeners.delete(id);
    }
    /** notifies all listeners with new data */
    notifyListeners(param) {
        this.listeners.forEach(callback => { callback(param); });
    }
}
//# sourceMappingURL=data-listener.js.map